export default {"src":"/_next/static/media/March-Baseline-Logo.84846da6.svg","height":613,"width":2500,"blurWidth":0,"blurHeight":0};